
export class BroadcastPortModel {
    id:number;
    portid:number;
}
